import {Checkbox} from "@atlaskit/checkbox";
import type {ComponentProps} from "react";

export function AnankeCheckbox(props: ComponentProps<typeof Checkbox>) {
    return <Checkbox {...props} />;
}
